var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gc-status-chip-yes-no"},[_c('label',{class:{
      active: _vm.status === 'Y',
      cancelled: _vm.status === 'N',
    },style:({
      'background-color':
        _vm.status === 'Y' ? '#62d26f' : _vm.status === 'N' ? '#e8384f' : '#e2e2e2',
    })},[_vm._v(_vm._s(_vm.getFriendlyStatus(_vm.status)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }